/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_EmptyInputs */

const cs_settings_users_empty = /** @type {(inputs: Settings_Users_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádní uživatelé.`)
};

const en_settings_users_empty = /** @type {(inputs: Settings_Users_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No users.`)
};

/**
* | output |
* | --- |
* | "No users." |
*
* @param {Settings_Users_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_empty = /** @type {((inputs?: Settings_Users_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_empty(inputs)
	return cs_settings_users_empty(inputs)
});